import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        {/* Left - Image */}
        <div className="lg:w-1/2 relative min-h-[300px] lg:min-h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20lifestyle%20flatlay%20with%20fashion%20items%20sneakers%20and%20accessories%20arranged%20on%20warm%20cream%20linen%20surface%20soft%20natural%20morning%20light%20elegant%20composition%20with%20negative%20space%20editorial%20product%20photography&width=900&height=700&seq=cta-left-v2-002&orientation=landscape&nocache=true"
            alt="OOPBuy Spreadsheet Produkte"
            className="w-full h-full object-cover"
            title="OOPBuy Spreadsheet – Jetzt entdecken"
            loading="lazy"
          />
          <div className="absolute top-6 left-6">
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest bg-background-50/80 backdrop-blur-sm px-3 py-1 rounded-full">
              {t('cta.tag')}
            </span>
          </div>
          <div className="absolute bottom-6 left-6 right-6">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight drop-shadow-lg">
              {t('cta.heading1')}
              <br />
              {t('cta.heading2')}
            </h2>
          </div>
        </div>

        {/* Right - Content */}
        <div className="lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-16">
          <div className="max-w-md text-center lg:text-left">
            <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
              {t('cta.heading1')}
              <br />
              {t('cta.heading2')}
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {t('cta.desc')}
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap group"
            >
              {t('cta.button')}
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}